module.exports = __webpack_public_path__ + "img/td.873d5c4b.svg";